import React, { useCallback, useRef, useState,useEffect } from 'react'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import TableListing from '../../components/TableListing/TableListing'
import requestApi from '../../utils/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import Pagination from '../../components/Pagination'
import { Col, Dropdown, Row } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import Swal from 'sweetalert2'
import ApproveDeclinePopup from '../../components/ApproveDeclinePopup/ApproveDeclinePopup'
import { categoryaddedit, subcategoryaddedit } from '../../config/routingConsts'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconEdit } from '../../assets/images/icons/icon-edit-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconRejected } from '../../assets/images/icons/icon-rejected-status.svg'
import { ReactComponent as IconApproveRight } from '../../assets/images/icons/icon-right-aprrove.svg'
import { ReactComponent as IconDesapproveClose } from '../../assets/images/icons/icon-close-desaprrove.svg'
import TableSkeleton from '../../components/TableSkeleton/TableSkeleton'
import StatusDropDown from '../../components/StatusDropDown/StatusDropDown'
import NoRecordFound from '../../components/NoRecordFound/NoRecordFound'
import InputControl from '../../components/InputControl'
import AddEditModal from '../../components/AddEditModal/AddEditModal'

import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

//#region get All Main Category 
const getAllMainCategory = async () => {
    const mainCats = await requestApi.post(
        '/main-category/list',
        {},
        { headers: true }
    )
    return mainCats.data
}
//#endregion

const SubCategoryManagement = () => {

      //#region From schema
  const categoryValidationSchema = yup.object().shape({
    categoryName: yup
        .string()
        .trim()
        .max(25, 'Must be at max 25 characters')
        .required('Please enter sub category name'),
    MainCategory2 :yup
    .object()
    .required('Please select main category')
    .test("error","Please select main cateogry name",(e)=>{
              return !!e.name? true:false
    })
})
//#endregion

    const options = ["Pending", "Active", "InActive", "Decline"];
    const [selectedOption, setSelectedOption] = useState("");
  
    const handleDropdownSelect = (option) => {
            setSelectedOption(option);
            if(selectedOption ==="All" || selectedOption)
            {
                setCurrentPage(1)
            }
    };

    const queryClient = useQueryClient()
    const navigate= useNavigate() 
    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [userFilterText, setuserFilterText] = useState('')
    const [sorting, setSorting] = useState([])
    const [filter, setFilter] = useState(null)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [isDeleteModal, setIsDeleteModal] = useState(false)

    const [MainCategory, setMainCategory] = useState(null)


    const [ShowMaterialStatusPopup, setShowMaterialStatusPopup] =
        useState(false)
    const [statusUpdate, setStatusUpdate] = useState(null)
    const [buttonText, setButtonText] = useState('')

    const [mainCategory, setmainCategory] = useState('')

    const [deleteId, setDelteId] = useState('')
    const EditDataRef = useRef(null)

    const {
        register,
        handleSubmit,
        control,
        formState: { errors }
    } = useForm()

    const handleSearch = useCallback((e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setSearchKeyword(e.target.value)
        }, 1000)
        clearInterval()
    }, [])

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    // const handleChange3=(e)=>{
    //   setmainCategory(e.target.value)
    // }

    // const handleChange = (eventkey) => {
    //     setDataLimit(eventkey)
    // }

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
      setopenAction(openAction === id ? null : id);
    };


    const { data: MainCategoryList } = useQuery({
        queryKey: ['maincategorylist', MainCategory],
        queryFn: getAllMainCategory
    })

    //#region  category Listing
    function UserList({ queryKey }) {
        return requestApi
            .post(
                `category/list`,
                {
                    search: queryKey[3],
                    limit: queryKey[2],
                    page: queryKey[1],
                    sortKey: queryKey[4]?.sortKey,
                    sortBy: queryKey[4]?.sortBy,
                    mainCategoryId:queryKey[5]?._id,
                    status:queryKey[6]
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data, isLoading } = useQuery({
        queryKey: [
            'categorylist',
            currentPage,
            DataLimit,
            searchKeyword,
            filter,
            MainCategory,
           selectedOption
        ],
        queryFn: UserList
    })
    //#endregion

    useEffect(() => {
        if (currentPage && data?.data?.length == 0) {
            setCurrentPage(currentPage - 1)
        } else {
        }
    }, [currentPage, data?.data])

    useEffect(()=>{
        setCurrentPage(1)
     },[searchKeyword])
 
    //#region Table Columns
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.accessor((row) => row?.mainCategoryName, {
            id: 'mainCategoryName',
            header: () => 'Main Category'
        }),
        columnHelper.accessor((row) => row?.categoryName, {
            id: 'categoryName',
            header: () => 'Category'
        }),
        columnHelper.accessor((row) => row?.status, {
            id: 'status',
            header: () => 'Status',
            enableSorting: false,
            cell: (row) => {
                switch (row?.row?.original?.status) {
                    case 7:
                        return (
                            <span className="pending-data status-data">
                                Pending
                            </span>
                        )
                        case 5:
                            return (
                                // <span className="decline-data status-data">
                                //     Decline
                                // </span>
                                <span class="rejected-status status-data"><IconRejected/> Rejected</span>
                            )

                    default:
                        return (
                            <>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={
                                            row?.row?.original?.status == 1
                                                ? true
                                                : false
                                        }
                                        onChange={(e) =>

                                            onStatusChange(
                                                row?.row?.original?.categoryId
                                            )
                                        }
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </>
                        )
                }
            }
        }),
        columnHelper.display({
            id: 'actions',
            header: () => 'Actions',
            cell: (row) => {
                    switch(row.row.original.status){
                        case 7:
                            return(
                                <>
                                  {/* <div className="action-data">
                                  <div className="action-icon"
                                 onClick={() => {
                                    handleApproveDecline(
                                        row?.row?.original?.categoryId,
                                        setButtonText("Decline")
                                    )
                                }}>
                                    <DeclineIcon />
                                </div>
                                <div
                                    className="action-icon"
                                    onClick={() => {
                                        handleApproveDecline(
                                            row?.row?.original?.categoryId,
                                            setButtonText("Approve")
                                        )
                                    }}
                                >
                                    <ApproveIcon />
                                </div>
                               
                                  </div> */}
                                <div className={`table-action ${row?.row?.original?.categoryId === openAction ? "active" : ""}`}  onMouseLeave={() => setopenAction(null)}>
                                    <div className={`action-btn ${row?.row?.original?.categoryId === openAction ? "active" : ""}`} onClick={() => OpenAction(row?.row?.original?.categoryId)}><IconsDots/></div>
                                    <div className='action-panel two-action'>
                                        <div className='action-btn-icon edit'
                                            onClick={() => {
                                                handleApproveDecline(
                                                    row?.row?.original?.categoryId,
                                                    setButtonText("Approve")
                                                )
                                            }}
                                        ><IconApproveRight/></div>
                                        <div className='action-btn-icon delete'
                                            onClick={() => {
                                                handleApproveDecline(
                                                    row?.row?.original?.categoryId,
                                                    setButtonText("Decline")
                                                )
                                            }}
                                        ><IconDesapproveClose/></div>
                                    </div>
                                </div>
                            </>
                            )

                          case 5:
                            return(
                                <>
                                -
                                </>
                            ) 
                            
                            default : return(
                                
                            //     <div className="action-data">
                            //               <div
                            //             className="action-icon"
                            //             onClick={() =>
                            //                 navigate(categoryaddedit, {
                            //                     state: row?.row?.original?.categoryId
                            //                 })
                            //             }
                            //         >
                            //             <EditIcon />
                            //         </div>
                            // <div
                            //     className="action-icon"
                            //     onClick={() =>
                            //         handleDeleteModal(row?.row?.original?.categoryId)
                            //     }
                            // >
                            //     <DeleteIcon />
                            // </div>
                            // </div> 

                            <div className={`table-action ${row?.row?.original?.categoryId === openAction ? "active" : ""}`}  onMouseLeave={() => setopenAction(null)}>
                                <div className={`action-btn ${row?.row?.original?.categoryId === openAction ? "active" : ""}`} onClick={() => OpenAction(row?.row?.original?.categoryId)}><IconsDots/></div>
                                <div className='action-panel two-action'>
                                    <div className='action-btn-icon edit'
                                        onClick={() =>
                                            // navigate(subcategoryaddedit, {
                                            //                         state: row?.row?.original?.categoryId
                                            //                  })
                                            handleAddEditModal(
                                                row?.row?.original
                                            )
                                        }
                                    ><IconEdit/></div>
                                    {/* <div className='action-btn-icon view'><IconView/></div> */}
                                    <div className='action-btn-icon delete'
                                    onClick={() =>
                                        handleDeleteModal(row?.row?.original?.categoryId)
                                    }
                                    ><IconDelete/></div>
                                </div>
                            </div>
                            )
                    }
            }
        })
    ]
    //#endregion

    const table = useReactTable({
        data: data?.data,
        columns: columns,
        // onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    //#region  Delete By ID
    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    function handleDelete(categoryId) {
        mutationDelete.mutate(categoryId)
        setIsDeleteModal(false)
    }
    async function deletecategoryId(categoryId) {
        return await requestApi.post(`category/delete`, {
            categoryId
        })
    }

    const mutationDelete = useMutation(deletecategoryId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('categorylist')
            setIsDeleteModal(false)
            EditDataRef.current = null
        },
        onError: (error) => {
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })
    //#endregion

    //#region approve type status
    const handleApproveDecline = (id) => {
        setShowMaterialStatusPopup(true)
        setStatusUpdate(id)
    }

    function handlePermission(categoryId) {
        mutationStatusUpdate.mutate(categoryId)
        setShowMaterialStatusPopup(false)
    }

    async function updateStatusbyId(categoryId) {
        if(buttonText=="Approve"){
            return await requestApi.post(`/category/approve-decline`, {
                categoryId,
                status:1
            })
        }else{
            return await requestApi.post(`/category/approve-decline`, {
                categoryId,
                status:5
            })
        }
    }

    const mutationStatusUpdate = useMutation(updateStatusbyId, {
        onSuccess: ({ data }) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            })
            queryClient.invalidateQueries('categorylist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })

    //#endregion

    //#region  Active/InActive Status Update
    const onStatusChange = useCallback((categoryId) => {
        mutationStatusActiveInactive.mutate(categoryId)
    }, [])
    async function updateStatusbycategoryId(categoryId) {
        return await requestApi.post(`/category/active-inactive-status`, {
            categoryId
        })
    }
    const mutationStatusActiveInactive = useMutation(updateStatusbycategoryId, {
        onSuccess: ({ data }) => {
            // Swal.fire({
            //     position: 'center',
            //     icon: 'success',
            //     title: '',
            //     text: data?.meta?.message
            // })
            queryClient.invalidateQueries('colorlist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

    //#region Modal for AddEdit
    const [AddEditShow, setAddEditShow] = useState(false)
    const [categoryId, setcategoryId] = useState('')

    const handleAddEditModal = (data) => {
        setAddEditShow(true)
        const { categoryName,mainCategoryId,mainCategoryName }= data
        msetValue('categoryName',categoryName)
        msetValue("MainCategory2",{name:mainCategoryName,mainCategoryId:mainCategoryId})
        setcategoryId(data.categoryId)
    }
    const handleAddEditModalForNew = () => {
        setAddEditShow(true)
        msetValue('categoryName',null)
        msetValue("MainCategory2",null)
        setcategoryId(null)
    }
    //#endregion

    const {
        register: mregister,
        handleSubmit: mhandleSubmit,
        formState: { errors: merrors },
        setValue: msetValue,
        control:mcontrol
    } = useForm({
        mode: 'onChange',
        resolver: yupResolver(categoryValidationSchema)
    })
    //#endregion

    console.log(merrors,"merrors");
    return (
        <div className="categories-management">
            <div className="admin-card">
                <div class="head">
                    <h2>Sub Category Management</h2>
                    <div className="search-btn-group">
                        {/* dropdown for filter sub-category using main-category */}
                        {/* <div className='filterDropdown'>
                        <Dropdown
                                            flip="no"
                                            onSelect={handleChange}
                                        >
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                {DataLimit}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="10">
                                                    10
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="20">
                                                    20
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="30">
                                                    30
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                        </div> */}
                        {/* end */}
                        <form
                            action=""
                            {...register('categorySearch', {
                                onChange: (e) => {
                                    handleSearch(e)
                                }
                            })}
                            className="product-table-filter"
                        >
                            <input
                                type="search"
                                name="categorySearch"
                                placeholder="Search"
                            />
                        </form>
                        <Controller
                            control={control}
                            name="MainCategory"
                            render={({
                                field: { onChange, onBlur, value, ref }
                            }) => (
                                <Dropdown
                                    flip="no"
                                    onSelect={(e) =>
                                        setMainCategory(JSON.parse(e))
                                    }
                                    name="MainCategory"
                                    drop="down-centered"
                                    {...register('MainCategory')}
                                >
                                    <Dropdown.Toggle
                                        variant="success"
                                        id="dropdown-basic"
                                    >
                                        {MainCategory?.name || 'Select Main Category'}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            eventKey={JSON.stringify({
                                                name: ''
                                            })}
                                        >
                                            All
                                        </Dropdown.Item>
                                        {MainCategoryList?.data?.map((mCat) => {
                                            return (
                                                <Dropdown.Item
                                                    key={mCat._id}
                                                    eventKey={JSON.stringify(
                                                        mCat
                                                    )}
                                                >
                                                    {mCat.name}
                                                </Dropdown.Item>
                                            )
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            )}
                        ></Controller>
                        {errors?.MainCategory && (
                            <span
                                className="error-message"
                                style={{ color: 'red' }}
                            >
                                {' '}
                                {errors?.MainCategory?.message}
                            </span>
                        )}
                        {/* </div> */}

                        {/* StatusDropDown Component Start*/}
                        <StatusDropDown
                            options={options}
                            onSelect={handleDropdownSelect}
                            selectedOption={selectedOption}
                        />
                           {/* StatusDropDown Component End */}

                        <button
                            className="solid-red-btn"
                            // onClick={() => navigate(subcategoryaddedit)}
                            onClick={() =>
                                handleAddEditModalForNew()
                             }
                        >
                            Add New Sub Category{' '}
                        </button>
                    </div>
                </div>
                {/* Loading */}
                {isLoading ? (
                    <TableSkeleton />
                ) : data?.data?.length > 0 ? (
                    <>
                        <TableListing table={table} className="m-0" getfilter={(e) => {setFilter(e)}} />
                        <div className="pagination-wrap">
                            <div className="showing-pages">
                                <span>
                                    Showing {(currentPage - 1) * DataLimit + 1}{' '}
                                    to{' '}
                                    {Math.min(
                                        currentPage * DataLimit,
                                        data.meta.totalCount
                                    )}{' '}
                                    of {data.meta.totalCount}{' '}
                                    {data.meta.totalCount > 1
                                        ? 'sub categories'
                                        : 'sub category'}
                                </span>
                            </div>

                            {data?.meta?.totalCount > 10 && (
                                <>
                                    {/* <div className="itemperpage-box">
                                            <span>Items per page:</span>
                                            <Dropdown
                                                flip="no"
                                                onSelect={handleChange}
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {DataLimit}
                                                </Dropdown.Toggle>
    
                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="10">
                                                        10
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="20">
                                                        20
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="30">
                                                        30
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div> */}

                                    <Pagination
                                        total={Math.ceil(
                                            data.meta.totalCount / DataLimit
                                        )}
                                        current={currentPage}
                                        onChangePage={handleChangePage}
                                    />
                                </>
                            )}
                        </div>
                    </>
                ) : (
                    <div className="no-record-found">
                        <NoRecordFound />
                        </div>
                )}
                <DeleteModal
                    message={<>Are you sure you want to Delete this<br/> Sub-Category ?</>}
                    setIsDeleteModal={setIsDeleteModal}
                    isDeleteModal={isDeleteModal}
                    handleDelete={() => handleDelete(deleteId)}
                />
                <ApproveDeclinePopup
                    ShowMaterialStatusPopup={ShowMaterialStatusPopup}
                    setShowMaterialStatusPopup={setShowMaterialStatusPopup}
                    setStatusUpdate={statusUpdate}
                    title={`Are you sure you want to ${buttonText} ?`}
                    // handlestatus={handlestatus}
                    text={buttonText}
                    handlePermission={() => handlePermission(statusUpdate)}
                />

            {/* AddEdit Modal Start */}
            <AddEditModal
                AddEditShow={AddEditShow}
                setAddEditShow={setAddEditShow}
                handleClose={() => setAddEditShow(false)}
            >
                <Child
                    register={mregister}
                    handleSubmit={mhandleSubmit}
                    errors={merrors}
                    setValue={msetValue}
                    control={mcontrol}
                    categoryId={categoryId}
                    setcategoryId={setcategoryId}
                    setAddEditShow={setAddEditShow}
                    queryClient={queryClient}
                    MainCategoryList={MainCategoryList}
                />
            </AddEditModal>
            {/* AddEdit Modal End */}

            </div>
        </div>
    )
}

export default SubCategoryManagement

//#region  Modal child Component
const Child = ({
    register,
    handleSubmit,
    errors,
    setValue,
    categoryId,
    setcategoryId,
    setAddEditShow,
    control,
    queryClient,
    MainCategoryList
}) => {

    //#region  SubCategory Add-Edit 
    async function subCategoryAddEditMethod(payload) {
        console.log(payload,"payload for Add/edit");
        try {
            if (categoryId) {
                return await requestApi
                    .post(`/category/add-edit`, {
                        categoryId: categoryId,
                        ...payload
                    })
                    .then((res) => {
                        return res.data
                    })
            } else {
                return await requestApi
                    .post(`/category/add-edit`,payload)
                    .then((res) => {
                        return res.data
                    })
            }
        } catch (error) {
            throw new Error(error.message)
        }
    }

    const mutation = useMutation(subCategoryAddEditMethod, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(() => {
                setAddEditShow(false)
                setcategoryId(null)
                setValue('categoryName',null)
                setValue("MainCategory2",null)
                queryClient.invalidateQueries('subcategorylist')
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })

    function handleSubcategoryAddEditSubmit(data) {
        console.log(data,"data");
        const payload = {
            categoryName:data?.categoryName,
            mainCategoryId: data?.MainCategory2?.mainCategoryId ? data?.MainCategory2?.mainCategoryId : data?.MainCategory2?._id
        }
        try {
            mutation.mutate(payload)
        } catch (error) {
            throw new Error(error)
        }
    }
    //#endregion

    return (
        <div
            className=" admin-card"
            id="categorymodal001"
            name="categorymodal"
            aria-label="modal_cateogry"
        >
            <div class="head">
                <h2> {categoryId ? 'Edit' : 'Add'} Sub Category</h2>
            </div>
            <div className="admin-form-body">
                <form onSubmit={handleSubmit(handleSubcategoryAddEditSubmit)}>
                    <Row>
                        <Col xxl="12" md="12">
                            <div className='form-group'>
                            <label >Select Category</label>
                            <Controller
                                control={control}
                                name="MainCategory2"
                                render={({ field: { onChange, onBlur, value, ref } }) => (          
                            <Dropdown
                            flip="no"
                            onSelect={(e)=>onChange(JSON.parse(e))}
                            name="MainCategory2"
                            drop="down-centered"
                        >
                            <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                            >  {value?.name || "Select Category" }      
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {MainCategoryList?.data?.map((mCat) => {
                                    return (
                                        <Dropdown.Item
                                            key={mCat._id}
                                            eventKey={JSON.stringify(mCat)}
                                        >
                                            {mCat.name}
                                        </Dropdown.Item>
                                    )
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                                )}
                                >
                            </Controller>
                                    {
                                errors?.MainCategory && (
                                        <span className="error-message" style={{ color: 'red' }}> {errors?.MainCategory?.message}</span>
                                    )
                                }
                            </div>
                        <InputControl
                            autoFocus={true}
                            label="Sub-Cateogry Name"
                            name="categoryName"
                            register={register}
                            error={errors?.categoryName?.message}
                        />
                        <button type="submit" className="solid-red-btn">
                            Save
                        </button>
                   
                        </Col>
                    </Row>
                </form>
            </div>
        </div>
    )
}
//#endregion